module.exports = __webpack_public_path__ + "img/collect.95ee5ecc.png";